import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { inject } from 'mobx-react';

import { BottomSheet } from 'public/components/BottomSheet';
import { parseAnnouncement } from 'public/helpers/contentful/parser';
import { track } from 'utils/analytics';

import BookTicketsAnnouncement from './BookTicketsAnnouncement';

import './book-tickets.less';

const BookTicketsSheet = inject('announcements')(function BookTicketsSheet({
  isOpen,
  onClose,
  announcements,
}) {
  const [ticketOptions, setTicketsOptions] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    track('Book tickets modal opened');
    announcements
      .fetchByType({ type: 'book-ticket' })
      .then((data) => {
        const list = Array.isArray(data) ? data : [data];
        setTicketsOptions(
          list
            .filter(Boolean)
            .map(parseAnnouncement)
            .sort((a, b) => a.order - b.order)
        );
      })
      .catch(() => setTicketsOptions([]));
  }, [isOpen]);

  const setActive = (active) => {
    if (!active) onClose();
  };

  return (
    <BottomSheet
      onClose={onClose}
      isOpen={Boolean(isOpen && ticketOptions.length)}
      title="Book tickets"
      content={
        <div style={{ padding: '12px' }}>
          {ticketOptions.map((option) => (
            <BookTicketsAnnouncement
              announcement={option}
              key={option.name}
              setActive={setActive}
            />
          ))}
        </div>
      }
    />
  );
});

BookTicketsSheet.propTypes = {
  isOpen: propTypes.bool,
  onClose: propTypes.func.isRequired,
};

export default BookTicketsSheet;
